import axios from 'axios';
import { downloadFile } from 'app/api/apiUtil';

const api = '/api/dispatch-notes';

export const findDispatchNotes = params => {
  const queryParams = params
    ? Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&')
    : '';

  return axios.get(`${api}?${queryParams}&cacheBuster=${new Date().getTime()}`);
};

export const getDispatchNote = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getAllOpenDispatchNotes = id => {
  if (id) {
    return axios.get(`${api}/all-open?contractId=${id}&cacheBuster=${new Date().getTime()}`);
  }

  return axios.get(`${api}/all-open?cacheBuster=${new Date().getTime()}`);
};

export const getNextDispatchNoteNr = () => {
  return axios.get(`${api}/next-dispatch-note-nr?cacheBuster=${new Date().getTime()}`);
};

export const generateDispatchNote = async id => {
  try {
    const response = await axios.get(`${api}/generate/${id}?cacheBuster=${new Date().getTime()}`, { responseType: 'blob' });
    downloadFile(response);
  } catch (error: any) {
    const data = error?.response?.data;

    if (data instanceof Blob) {
      const text = await data.text();

      throw JSON.parse(text);
    }

    throw error;
  }
};

export const downloadDispatchNote = async (id: number) => {
  const response = await axios.get(`${api}/download/${id}?cacheBuster=${new Date().getTime()}`, {
    responseType: 'blob', // This is important for downloading the file as a binary
  });
  downloadFile(response);
};
